import AppShell from "@/components/layout/AppShell";
import PageHeader from "@/components/ui/PageHeader";
import { Table, TD, TH, THead } from "@/components/ui/Table";
import { store } from "@/lib/store";

export default function InventoryPage() {
    const movements = store.getInventoryMovements();

    return (
        <AppShell>
            <PageHeader title="Inventory" description="Track stock movement history." />
            <Table>
                <table className="min-w-full border-collapse">
                    <THead>
                        <tr>
                            <TH>Date</TH>
                            <TH>Variant SKU</TH>
                            <TH>Type</TH>
                            <TH>Qty</TH>
                            <TH>Notes</TH>
                        </tr>
                    </THead>
                    <tbody>
                        {movements.map((movement) => (
                            <tr key={movement.id} className="border-t border-rose-50">
                                <TD>{new Date(movement.createdAt).toLocaleString()}</TD>
                                <TD>{movement.variantSku}</TD>
                                <TD>{movement.type}</TD>
                                <TD>{movement.qty}</TD>
                                <TD>{movement.notes}</TD>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </Table>
        </AppShell>
    );
}